import { BaseLayout } from "./BaseLayout";
import { StandardMenuLayout } from "./StandardMenuLayout";
import { StandardContentLayout } from "./StandardContentLayout";
import { DialogMenuLayout } from "./DialogMenuLayout";
import { ParentChildContentLayout } from "./ParentChildContentLayout";

export class LayoutProvider {
    menuLayouts: { [mode: string]: BaseLayout };

    constructor() {}

    getMenuLayout(mode: string, layout: kendo.Layout, viewModel: Object): BaseLayout {
        switch (mode) {
            case "standard":
                return new StandardMenuLayout(layout, viewModel);
            case "dialog":
                return new DialogMenuLayout(layout, viewModel);
        }
    }

    getContentLayout(mode: string, layout: kendo.Layout, viewModel: Object): BaseLayout {
        switch (mode) {
            case "standard":
                return new StandardContentLayout(layout, viewModel);
            case "parentchild":
                return new ParentChildContentLayout(layout, viewModel);
        }
    }
}
